function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10 5c0 1.103.897 2 2 2s2-.897 2-2-.897-2-2-2-2 .897-2 2zm5.447 3.614l2.972 5.146a4.998 4.998 0 00-1.73 1.004L13.75 9.677l-.506-.877A4 4 0 1116 5a3.98 3.98 0 01-1.071 2.718l.518.896zM4 20.5c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm3.383-5.673l-.513.89a4 4 0 11-1.707-1.044l.51-.883 2.951-5.112a4.996 4.996 0 001.713 1.031l-2.954 5.118zM20 20.5c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm0-6a4 4 0 010 8 3.998 3.998 0 01-3.869-3H8.899a4.992 4.992 0 000-2h7.232a3.998 3.998 0 013.869-3z"
  }));
}
export default SvgIconApps;